var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { keyframes } from '@emotion/react';
import { canvas, borderRadius } from '@workday/canvas-kit-react/tokens';
import { styled } from '@workday/canvas-kit-react/common';
/**
 * Keyframe for the dots loading animation.
 */
var keyframesLoading = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0%,\n  80%,\n  100% {\n    transform: scale(0);\n}\n  40% {\n    transform: scale(1);\n}"], ["\n  0%,\n  80%,\n  100% {\n    transform: scale(0);\n}\n  40% {\n    transform: scale(1);\n}"])));
/**
 * The actual loading dot div.
 */
var LoadingAnimationDot = styled('div')({
    backgroundColor: canvas.colors.soap400,
    width: canvas.space.s,
    height: canvas.space.s,
    fontSize: '0px',
    borderRadius: borderRadius.circle,
    transform: 'scale(0)',
    display: 'inline-block',
    marginRight: canvas.space.xxs,
    animationName: keyframesLoading,
    animationDuration: '1400ms',
    animationIterationCount: 'infinite',
    animationTimingFunction: 'ease-in-out',
    animationFillMode: 'both',
    '&:last-child': {
        marginRight: 0,
    },
}, function (_a) {
    var animationDelay = _a.animationDelay;
    return ({
        animationDelay: animationDelay + 'ms',
    });
});
/**
 * A simple container for the loading dots.
 */
var Container = styled('div')({
    display: 'inline-block',
});
/**
 * A simple component that displays three horizontal dots, to be used when some data is loading.
 */
export function LoadingDots(props) {
    var elemProps = __rest(props, []);
    return (React.createElement(Container, __assign({}, elemProps),
        React.createElement(LoadingAnimationDot, { animationDelay: 0 }),
        React.createElement(LoadingAnimationDot, { animationDelay: 160 }),
        React.createElement(LoadingAnimationDot, { animationDelay: 320 })));
}
var templateObject_1;
